import { useQuery } from '@tanstack/react-query';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { MasterPoolDetails, MasterPoolLoanComposition } from '../../HbtMasterPool/types';
import {
  getMasterPoolDetail,
  getMasterPoolLoansAndCompositions
} from '../../HbtMasterPool/ValidationInventoryService';

export const useMasterPoolTableDetails = (masterPoolCmhcAccountNumber: string) => {
  const authContext = useAuthenticationContext();

  return useQuery<MasterPoolDetails[], Error>({
    queryKey: ['masterPoolDetails', masterPoolCmhcAccountNumber],
    enabled: !!masterPoolCmhcAccountNumber,
    queryFn: async () => {
      const result = await getMasterPoolDetail(masterPoolCmhcAccountNumber, authContext);

      if (!result) {
        throw new Error('no_data_error');
      }

      return result;
    },
    retry: 1
  });
};

export const useLoansCompositions = (masterPoolCmhcAccountNumber: string) => {
  const authContext = useAuthenticationContext();

  return useQuery<MasterPoolLoanComposition[], Error>({
    queryKey: ['LoansCompositions', masterPoolCmhcAccountNumber],
    enabled: !!masterPoolCmhcAccountNumber,
    queryFn: async () => {
      const result = await getMasterPoolLoansAndCompositions(
        masterPoolCmhcAccountNumber,
        authContext
      );
      if (!result) {
        throw new Error('no_data_error');
      }

      return result;
    },
    retry: 1,
    staleTime: 0
  });
};
